module.exports = __webpack_public_path__ + "img/bar-chart-stacked-light-01.aa8bf237.jpg";